import { useEffect, useRef } from 'react';

/**
 * Returns previous value of the provided one.
 * @param {any} value The value to keep track of.
 * @returns {any} Returns previous value.
 */
export function usePrevious<T>(value: T): T | undefined {
  const previousValueRef = useRef<T>();

  useEffect(() => {
    previousValueRef.current = value;
  }, [value]);

  return previousValueRef.current;
}
